/**
 * Break tables so they print properly in headless chrome
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/dimensions/offset/offset.js";
import "dabbyjs/src/dimensions/width-height/width-height.js";
import "dabbyjs/src/traversal/add/add.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/traversal/next-prev/next-prev.js";

function isBlock(obj) {
	const style = getComputedStyle(obj);
	if (["block", "table", "table-row-group", "table-header-group", "table-footer-group", "table-row", "flex"].indexOf(style.display) === -1) {

	} else if (["static", "relative"].indexOf(style.position) === -1) {

	} else if (style.position === "relative" && parseInt(style.top) + parseInt(style.left) !== 0) {

	} else {
		return true;
	}
	return false;
}

function findElement(obj, y) {
	let found;
	obj.children().each((i, item) => {
		const $this = $(item);
		if (isBlock(item)) {
			const top = $this.offset().top;
			if (top < y && top + $this.outerHeight() >= y && (found = findElement($this, y)) === false) {
				found = $this;
				return false;
			}
		}
	});
	return found ? found : false;
}

export default (obj, height) => {
	if (obj.length) {
		let element,
			pages = $(),
			split = $(),
			offset = height;

		// get elements on the page boundary
		while ((element = findElement(obj, offset)) !== false && !split.is(element)) {
			split = split.add(element);
			offset = element.offset().top + (height * Math.ceil(element.outerHeight() / height)); // add how many pages the current content fits into
		}

		// add the page breaks
		split.each((i, item) => {

			// find the element on the page boundary in the viewport
			const page = $("<section>").addClass("page-break"),
				$this = $(item),
				parents = $this.add($this.parentsUntil(obj));

			// consume all the children until we hit the parent of the element on the page line
			obj.children(":not(script)").each((i, item) => {
				const $this = $(item);

				// move all previous siblings that are not in the target child chain
				if (!$this.is(parents)) {
					page.append(item);

				// split and move elements from the document to the new page
				} else {
					let temp = $();
					parents.each((i, item) => {
						const parent = $(item),
							first = parent.is(":first-child");
						if (!first || temp.length) {

							// if there are nodes from the previous level, clone the current node and add below
							if (temp.length) {
								temp = $(item.cloneNode()).append(temp);
							}

							// if current node is not first child, add previous sibling to collection
							if (!first) {
								temp = $(parent.prevAll().get().reverse()).add(temp);
							}
						}
					});
					page.append(temp);
					return false;
				}
			});
			pages = pages.add(page);
		});

		// add the pages to the root
		if (pages.length) {

			// collate what is left into a page
			const children = obj.children(":not(script)");
			if (children.length) {
				pages = pages.add($("<section>").addClass("page-break").append(children));
			}

			// attach the pages
			obj.prepend(pages);
		}
	}
};
